import React from 'react'
import WhatWeDoHero from '../../components/WhatWeDoComponets/WhatWeDoHero'
import ServicesSection from '../../components/WhatWeDoComponets/ServicesSection'
import TechnologiesSection from '../../components/WhatWeDoComponets/TechnologiesSection'
import TestimonialsSection from '../../components/WhatWeDoComponets/TestimonialsSection'
// import ProcessSection from '../../components/WhatWeDoComponets/ProcessSection'

const WhatWeDoPage = () => {
  return (
    <div className='WhatWeDoPage my-10 py-10 sm:p-10'>
      <WhatWeDoHero />
      <ServicesSection />
      {/* <ProcessSection /> */}
      <TechnologiesSection />
      <TestimonialsSection />
    </div>
  )
}

export default WhatWeDoPage
